module.exports = __webpack_public_path__ + "img/LATAM_CHEESE.5e80b62e.png";